import {Component, OnInit} from '@angular/core';
import {User} from '../../classes/User';
import {LocalStorageService} from '../../services/local-storage.service';
import {UserService} from '../../services/user/user.service';
import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-profile',
  styleUrls: ['./profile.component.scss'],
  templateUrl: './profile.component.html',
})
export class ProfileComponent implements OnInit {

  public currentUser: User;
  public language: string;
  public isAdmin = false;

  constructor(private userService: UserService,
              private localStorageService: LocalStorageService,
              public languageService: LanguageService) { }

  public ngOnInit(): void {
    this.userService.getCurrentUser()
      .subscribe(
        (data: User) => {
          this.currentUser = data;
          this.isAdmin = this.currentUser.roles.includes('ROLE_ADMIN');
          this.language = this.languageService.getLangByEnumValue(this.currentUser.language);
          this.localStorageService.saveUser(this.currentUser);
        },
      );
  }

}
